/** Public referral link to this app's `/ambassador/:code` route. */
export const getAmbassadorLink = (code: string) =>
  `${window.location.origin}/ambassador/${code}`
